import { createEmitter } from '@/shared/lib/emitter';

/**
 * @deprecated
 * @refactor Временное решение. Переписать на хук useBaseUpload в рамках рефакторинга на fsd
 * @see src/components/hf/applicant-comment-attachments/base-attachments.vue
 * @see src/components/ui/base-upload/base-upload.vue
 */
export const baseUploadEmitter = createEmitter();
